import * as actionTypes from './actionTypes';
import axios from '../../services/axios'
import { setMessage } from './message';

export const loadStudents = () => {
    return {
        type: actionTypes.LOAD_STUDENTS
    }
}

export const setStudents = (students) => {
    return {
        type: actionTypes.SET_STUDENTS,
        students: students
    }
}

export const getStudents = (currentPage, criteria) => {
    return (dispatch) => {
        dispatch(loadStudents())
        axios.post(`/api/v1/profiles`, {
            course: criteria.course,
            currentPage: currentPage,
            faculties: criteria.faculties,
            lastName: criteria.lastName,
            searchJob: criteria.searchJob,
            skills: criteria.skills
        })
            .then(response => {
                dispatch(setStudents(response.data))
            })
            .catch(() => {
                dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
            });
    }
}

export const loadAvailableFaculties = () => {
    return {
        type: actionTypes.LOAD_AVAILABLE_FACULTIES
    }
}

export const setAvailableFaculties = (faculties) => {
    return {
        type: actionTypes.SET_AVAILABLE_FACULTIES,
        faculties: faculties
    }
}


export const getAvailableFaculties = () => {
    return (dispatch) => {
        dispatch(loadAvailableFaculties())
        axios.get(`/api/v1/schedule/faculties`)
            .then(response => {
                dispatch(setAvailableFaculties(response.data))
            })
            .catch(() => {
                dispatch(setAvailableFaculties([]))
                dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
            });
    }
}

export const loadStudentGroupReportDownload = () => {
    return {
        type: actionTypes.LOAD_STUDENT_GROUP_REPORT_DOWNLOAD
    }
}

export const onLoadStudentGroupReportDownloadStopped = () => {
    return {
        type: actionTypes.SAVE_STUDENT_GROUP_REPORT_DOWNLOAD
    }
}

export const getStudentGroupReportDownload = () => {
    return (dispatch) => {
        dispatch(loadStudentGroupReportDownload())
        axios.get('/api/v1/group-list/get-report',{
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/vnd.ms-excel'
                }
            }
        ).then(response => {
            dispatch(saveReport(response))
            dispatch(setMessage({type: 'success', text: "Список группы загружен."}));
        }).catch(_error => {
            dispatch(setMessage({type: 'error', text: "Не удалось загрузить список группы."}))
            dispatch(onLoadStudentGroupReportDownloadStopped())
        });
    }
}

export const saveReport = (response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    let filename = 'Список группы.xlsx';
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    return onLoadStudentGroupReportDownloadStopped();
}